import { useLang } from "../i18n";
import Seo, { breadcrumbLd } from "../components/Seo";
import { Reveal, Kicker, MaskLine } from "../components/Reveal";
import ContactForm from "../components/ContactForm";

export default function ContactPage() {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";

  return (
    <div data-testid="contact-page" className="pt-32">
      <Seo
        title={t("seo.contact.title")}
        desc={t("seo.contact.desc")}
        path="/contacto"
        jsonLd={breadcrumbLd([
          { name: "EcoGlow Detailing", path: prefix || "/" },
          { name: t("nav.contact"), path: `${prefix}/contacto` },
        ])}
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal><Kicker>{t("contact.kicker")}</Kicker></Reveal>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskLine delay={0.1}>{t("contact.heading")}</MaskLine>
        </h1>
        <Reveal delay={0.3}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">{t("contact.sub")}</p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
        <Reveal delay={0.1}>
          <ContactForm />
        </Reveal>
      </section>
      <div className="pb-10" />
    </div>
  );
}
